export const config = {
	weatherKey: '8032d9dc8d965fec9c545e4c6fe8ec3c'
};
